// @fileoverview : 기준정보 > 경남-권한선택
import { MenuListUpdateForm } from "@/features/menuList/form/updateForm";
import { useModal } from "@/features/modal/ModalStackManager";
import { Header } from "@/features/standard/Header";
import { HeaderSubTitle } from "@/features/standard/SubTitle";
import { HeaderTitle } from "@/features/standard/Title";
import { Wrapper } from "@/features/standard/Wrapper";
import { useStandardLayout } from "@/features/standardLayout/Context";
import { Filter } from "@/features/standardLayout/Filter";
import { ListTable } from "@/features/standardLayout/ListTable";
import { PaginationBox } from "@/features/standardLayout/PaginationBox";
import { SearchBox } from "@/features/standardLayout/SearchBox";
import { Sorter } from "@/features/standardLayout/Sorter";
import { ActionHeader } from "@/features/standardLayout/StandardInfoActionHeader";
import {
  flexGrowable,
  flexStable,
  StandardLayoutTableWrapper,
} from "@/features/standardLayout/Styles";
import styled from "@emotion/styled";
import { ActionIcon, Avatar, Button, Flex, Text, Tooltip } from "@mantine/core";
import {
  MenuListsGet200Response,
  MenuListsGet200ResponseRowsInner,
} from "@sizlcorp/sizl-api-document/dist/models";
import { IconEdit, IconFilterPlus } from "@tabler/icons-react";
import type { Column } from "react-data-grid";
import { useTranslation } from "react-i18next";

const MenuList = {
  Header: Header,
  HeaderTitle: HeaderTitle,
  HeaderSubTitle: HeaderSubTitle,
  ActionHeader: ActionHeader,
  ActionButton: Button,
  Wrapper: Wrapper,
  UpdateForm: MenuListUpdateForm,
  // CreateForm: CommonCodeCreateForm,
  // UpdateForm: CommonCodeUpdateForm,
  // PartCreateForm: CommonPartCodeCreateForm,
  // PartUpdateForm: CommonPartCodeUpdateForm
};

export const MenuListPage = () => {
  const { openModal, closeModal } = useModal();

  const { selectedRows, refetch } = useStandardLayout();

  const { t } = useTranslation();

  const columns: readonly Column<MenuListsGet200ResponseRowsInner>[] = [
    {
      key: "parentCode",
      name: t("menuList.parentCode"),
      sortable: true,
      resizable: true,
    },
    {
      key: "code",
      name: t("menuList.code"),
      sortable: true,
      resizable: true,
    },
    {
      key: "name",
      name: t("menuList.name"),
      sortable: true,
      resizable: true,
    },
    {
      key: "options",
      name: "액션",
      sortable: true,
      resizable: true,
      formatter: (formatterProps) => {
        const updatePartnerActionView = () => {
          openModal(
            <MenuList.UpdateForm formatterProps={formatterProps.row} />,
            null,
            t("common.edit", { item: t("menuList.menuList") }),
            true
          );
        };

        return (
          <Flex w="100%" h="100%" justify="center" align="center" gap="md">
            <ActionIcon variant="subtle" onClick={updatePartnerActionView} color="yellow">
              <IconEdit />
            </ActionIcon>
          </Flex>
        );
      },
    },
  ];

  return (
    <Flex w="100%" h="100%" gap="xs" direction="column">
      {/* <Flex p="sm" justify="space-between" rowGap="md">
        <ActionHeader
          createFn={() =>
            openModal(
              <MenuListCreateForm />,
              null,
              `${t("common.additional", { item: t("menuList.menuList") })}`,
              true
            )
          }
          createDataTitle={t("menuList.menuList")}
          deleteFn={() => {}}
        />
      </Flex> */}
      {
        <Flex px="sm" direction="column" gap="xs">
          <Text fz="xl" fw={600}>
            {t("common.list", { item: t("menuList.menuList") })}
          </Text>
          <Text fz="xs">{t("common.subTitle", { item: t("menuList.menuList") })}</Text>
        </Flex>
      }
      <Flex justify="space-between" align="flex-start" px="sm">
        <Flex wrap="wrap" styles={flexGrowable}>
          <Flex gap="xs" align="center" h="100%" wrap="wrap" direction="row">
            <Tooltip label={t("common.filterDescription")}>
              <Avatar color="blue" variant="outline">
                <IconFilterPlus />
              </Avatar>
            </Tooltip>
            <Flex direction="column" gap="xs" wrap="wrap">
              <Filter />
              <Sorter />
            </Flex>
          </Flex>
        </Flex>
        <Flex styles={flexStable}>
          <SearchBox />
        </Flex>
      </Flex>
      <Flex w="100%" h="100%" p="sm" justify="space-between" gap="md" direction="column">
        <StandardLayoutTableWrapper>
          <ListTable<MenuListsGet200Response, MenuListsGet200ResponseRowsInner> columns={columns} />
        </StandardLayoutTableWrapper>
        <PaginationBox<MenuListsGet200Response> />
      </Flex>
    </Flex>
  );
};

const OptionBox = styled.fieldset`
  display: flex;
  gap: 10px;
  border: none;
`;

const OptionBtn = styled<any>(Button)`
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
